require('./product-categories-container.scss')

module.exports = {
  template: require('./product-categories-container.pug')()
  controller: require('./product-categories-container.ctrl')
}
